import * as React from 'react';
import { text } from 'src/common/text';
import '../styles/Separator.css';

export const Separator: React.FC<{ style?: React.CSSProperties }> = ({ style }) => {
  return (
    <div style={style} className="separator">
      <span className="separator__title">{text('LBL_OR')}</span>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/Separator.tsx